var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useLayoutEffect, useRef, useState, } from 'react';
import styled from 'styled-components';
export function DraggableModal(props) {
    var children = props.children, start = props.start;
    var ref = useRef(null);
    var _a = useState(false), dragging = _a[0], setDragging = _a[1];
    var _b = useState({ x: 10, y: 10 }), location = _b[0], setLocation = _b[1];
    var _c = useState({ x: 0, y: 0 }), mouseDif = _c[0], setMouseDif = _c[1];
    function handleMouseUp() {
        setDragging(false);
    }
    function clampX(x) {
        var current = ref.current;
        if (current) {
            var thisWidth = current.offsetWidth;
            var windowWidth = window.innerWidth;
            // x can be between 0 and windowWidth - thisWidth
            return Math.min(Math.max(0, x), windowWidth - thisWidth);
        }
        return x;
    }
    function clampY(y) {
        var current = ref.current;
        if (current) {
            var thisHeight = current.offsetHeight;
            var windowHeight = window.innerHeight;
            // y can be between 50 (header) and windowWidth - thisWidth
            return Math.min(Math.max(59, y), windowHeight - thisHeight);
        }
        return y;
    }
    function handleMouseDownOnDraggable(event) {
        var isTarget = !!event.target.dataset.target;
        if (!location)
            return;
        if (isTarget) {
            setMouseDif({
                x: event.pageX - location.x,
                y: event.pageY - location.y,
            });
            setDragging(true);
        }
    }
    function handleMouseMove(event) {
        if (dragging) {
            var x = clampX(event.pageX - mouseDif.x);
            var y = clampY(event.pageY - mouseDif.y);
            setLocation({ x: x, y: y });
        }
    }
    useEffect(function () {
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return function () {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging]);
    // handle adding custom drag targets
    // handle init position
    useLayoutEffect(function () {
        if (start && ref.current) {
            var x = 0;
            var y = 69;
            if (start === 'top right') {
                x = clampX(window.innerWidth - ref.current.offsetWidth - 10);
                setLocation({ x: x, y: y });
            }
        }
    }, []);
    return (_jsx(Container, __assign({ dragging: dragging, ref: ref }, location, { onMouseDown: handleMouseDownOnDraggable }, { children: children }), void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: ", "px;\n  top: ", "px;\n\n  [data-target] {\n    cursor: ", " !important;\n  }\n"], ["\n  position: fixed;\n  left: ", "px;\n  top: ", "px;\n\n  [data-target] {\n    cursor: ", " !important;\n  }\n"])), function (_a) {
    var x = _a.x;
    return x;
}, function (_a) {
    var y = _a.y;
    return y;
}, function (_a) {
    var dragging = _a.dragging;
    return (dragging ? 'grabbing' : 'grab');
});
var templateObject_1;
